import { RIGHT_ARROW_CHARACTER } from '@/constants/stringVars';
import { text } from '@/theme/colors/palettes';
import { Text } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import React from 'react';

const NavigateToGrowthZone = () => {
  const navigate = useNavigate();

  return (
    <Text
      onClick={() => navigate({ to: '/user/growth-zone' })}
      cursor={'pointer'}
      variant={'urbanistExtraBoldSmall12'}
      color={text.mediumBlue}
      _hover={{ fontWeight: 900 }}
    >
      My Growth Zone {RIGHT_ARROW_CHARACTER}
    </Text>
  );
};

export default NavigateToGrowthZone;
